import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-shell" }
const _hoisted_2 = { class: "login-right" }
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = ["min", "max"]
const _hoisted_8 = { class: "input-field" }
const _hoisted_9 = { class: "input-field" }
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = { class: "consent-field" }
const _hoisted_12 = {
  key: 0,
  class: "login-error"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "login-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createStaticVNode("<section class=\"login-left\" aria-hidden=\"true\" data-v-c3135174><div class=\"brand-panel\" data-v-c3135174><div class=\"brand-mark\" data-v-c3135174>OT</div><h2 class=\"brand-name\" data-v-c3135174>Obra Tycoon</h2><p class=\"brand-tagline\" data-v-c3135174>Comece agora. Sua obra estará no ar em menos de 1 minuto.</p><ul class=\"brand-features\" data-v-c3135174><li data-v-c3135174>Um sistema exclusivo por obra</li><li data-v-c3135174>Acesso via subdomínio próprio</li><li data-v-c3135174>Convide sua equipe depois</li></ul></div></section>", 1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "login-header" }, [
          _createElementVNode("span", { class: "login-product" }, "Obra Tycoon"),
          _createElementVNode("h1", { class: "login-title" }, "Registrar obra"),
          _createElementVNode("p", { class: "login-subtitle" }, "Crie o administrador e o sistema da obra.")
        ], -1)),
        _createElementVNode("form", {
          class: "form-grid",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "name" }, "Nome do perfil", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              type: "text",
              placeholder: "Ex.: Ana Souza",
              autocomplete: "name"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "username" }, "Nome de usuário", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
              type: "text",
              placeholder: "Ex.: ana.souza",
              autocomplete: "username"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "birthDate" }, "Data de nascimento", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "birthDate",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.birthDate) = $event)),
              type: "date",
              min: _ctx.MIN_BIRTH_DATE,
              max: _ctx.maxBirthDate(),
              autocomplete: "bday",
              required: ""
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.birthDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "password" }, "Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              placeholder: "Digite uma senha",
              autocomplete: "new-password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "field-divider" }, [
            _createElementVNode("span", null, "Dados da obra")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "projectName" }, "Nome da obra", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "projectName",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.projectName) = $event)),
              type: "text",
              placeholder: "Ex.: Obra Centro 2026"
            }, null, 512), [
              [_vModelText, _ctx.projectName]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "systemUsername" }, "Identificador da obra", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "systemUsername",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.systemUsername) = $event)),
              type: "text",
              placeholder: "Ex.: obracentro",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.systemUsername]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-hint" }, [
              _createTextVNode("Usado no URL: "),
              _createElementVNode("strong", null, "obracentro"),
              _createTextVNode(".obratycoon.com.br")
            ], -1))
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.acceptedTerms) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.acceptedTerms]
            ]),
            _createElementVNode("span", null, [
              _cache[18] || (_cache[18] = _createTextVNode("Li e aceito o ", -1)),
              _createVNode(_component_router_link, {
                to: "/termos",
                target: "_blank"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("Termo de Uso", -1)
                ]))]),
                _: 1
              }),
              _cache[19] || (_cache[19] = _createTextVNode(" e a ", -1)),
              _createVNode(_component_router_link, {
                to: "/privacidade",
                target: "_blank"
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode("Política de Privacidade", -1)
                ]))]),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createTextVNode(".", -1))
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn-primary",
            type: "submit",
            disabled: _ctx.loading || !_ctx.acceptedTerms
          }, _toDisplayString(_ctx.loading ? 'Criando obra...' : 'Criar obra e entrar'), 9, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "link-btn",
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
            }, "Já tenho conta")
          ])
        ], 32)
      ])
    ])
  ]))
}